export default function PropSection({ title, children }) {
    return (
        <div className="prop-section">
            <p className="prop-section-title">{title}</p>
            {children}
        </div>
    );
}
